module.exports = __webpack_public_path__ + "assets/img/logo_makou.5fe245f3.png";